/// <reference path="../../../../teva/selectbox/selectbox.ts" />
/// <reference path="../../../../teva/htmlhelpers/htmlhelpers.ts" />

namespace OfficeGuy.Inputs {
    export class Material {
        static Init(Container = null) {
            $(".sumit-field:not(.sumit-field-initialized)", Container)
                .off("focus.sumit-field")
                .on("focus.sumit-field", "input, select, textarea", function () {
                    $(this).closest(".sumit-field").addClass("sumit-field-active");
                })
                .off("focusout.sumit-field, change.sumit-field")
                .on("focusout.sumit-field, change.sumit-field", "input, select, textarea", function () {
                    var $this = $(this);
                    if ($this.is(":focus") || $this.hasClass("teva-selectbox-hiddeninput"))
                        return;
                    var $LineContainer = $this.closest(".sumit-field");
                    $LineContainer
                        .removeClass("sumit-field-active")
                        .toggleClass("sumit-field-populated", Material.HasValue($LineContainer));
                })
                .each(function () {
                    var $this = $(this);
                    if (Material.HasValue($this))
                        this.addClass("sumit-field-populated");
                });

            setTimeout(function () {
                $(".sumit-field", Container).addClass("sumit-field-initialized");
            }, 1);
        }
        static HasValue($Container) {
            var $Input = $Container.find("input:not(.schemaid):not(.teva-selectbox-search-terms-input), textarea");
            for (var i = 0; i < $Input.length; i++) {
                var $SingleInput = $($Input[i]);
                if ((<string>$SingleInput.val()).length > 0 || ($SingleInput.attr("placeholder") != null && $SingleInput.attr("placeholder").length > 0))
                    return true;
                var SelectBox = Teva.SelectBox.GetInstance($SingleInput);
                if (SelectBox != null && SelectBox.SelectedText != null && SelectBox.SelectedText.length > 0)
                    return true;
            }

            var Select = $Container.find("select");
            for (var i = 0; i < Select.length; i++)
                if ($(Select[i]).text().length > 0)
                    return true;

            return false;
        }

        static DisableNumericScroll() {
            $(document).on("focus.number", "input[type=number]:not(.enable-scroll)", function () {
                $(this).on("mousewheel.disableScroll", function (Event) {
                    Event.preventDefault();
                });
            })
            $(document).on("blur.number", "input[type=number]:not(.enable-scroll)", function () {
                $(this).off("mousewheel.disableScroll");
            })
            $(document).on("keydown.number", "input[type=number]:not(.enable-scroll)", function (Event) {
                return Event.key != "ArrowDown" && Event.key != "ArrowUp";
            })
        }
    }
}

$(document).on("Teva.Init", function () {
    OfficeGuy.Inputs.Material.DisableNumericScroll();
});

$(document).on("Teva.InitEditors", function (Event, Container) {
    OfficeGuy.Inputs.Material.Init(Container);
});